import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightSearchResult',
})
export class HighlightSearchResultPipe implements PipeTransform {
  transform(text?: string, searchTerm?: string, trimToElement?: HTMLElement): string {
    if (!searchTerm) {
      return text || '';
    }

    const highlightedTerm = `<b>${searchTerm}</b>`;

    let textWithHighlight =
      text?.toLowerCase()?.replaceAll(searchTerm.toLowerCase(), highlightedTerm) || '';
    if (trimToElement) {
      const textBeforeHighlight = textWithHighlight.indexOf(highlightedTerm); //each letter is about 9px
      const maxLettersAllowed = (trimToElement.offsetWidth * 2 + 10) / 9; // 2 lines + 10 is for the <b> and </b> tags
      if (textBeforeHighlight + searchTerm.length > maxLettersAllowed) {
        const textToShow = textWithHighlight.slice(
          textBeforeHighlight + searchTerm.length - maxLettersAllowed,
        );
        textWithHighlight = '...' + textToShow;
      }
    }

    return textWithHighlight;
  }
}
